import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, tap } from 'rxjs/operators';
import { WorkOrderModel } from "src/app/models/workOrder/workOrder.model";

@Injectable({
    providedIn: 'root'
})
export class WorkOrderService {

    private WORKORDER_URL = 'api/workOrder/'
    private UPLOAD_URL = 'api/workOrder/upload'


    constructor(
        private _httpClient: HttpClient
    ) {
    }


    getWorkOrders$(id: number): Observable<WorkOrderModel[]> {
        return this._httpClient.get<WorkOrderModel[]>(`${this.WORKORDER_URL}${id}`);
    }

    uploadFile(formData: FormData): Observable<any> {
        return this._httpClient.post('api/workOrder/upload', formData);
    }

    matchFile(formData: FormData): Observable<any> {
        return this._httpClient.post('api/workOrder/match', formData).pipe(
            tap(response => {

            }),
            catchError(error => {
                return of(error.error || 'Unkknown error');
            }),
        );
    }

    matchManufacturingFile(formData: FormData): Observable<any> {
        return this._httpClient.post('api/workOrder/manufacturingMatch', formData).pipe(
            tap(response => {

            }),
            catchError(error => {
                return of(error.error || 'Unkknown error');
            }),
        );
    }

    downloadLogs$(): Observable<Blob> {
        return this._httpClient.get(
            'api/workOrder/downloadLogs',
            { responseType: 'blob' }
        );
    }

    register(formData: FormData): Observable<any> {
        return this._httpClient.post('api/workOrder/register', formData).pipe(
            tap(response => {

            }),
            catchError(error => {
                return of(error.error || 'Unkknown error');
            }),
        );
    }

    getJobStatus(jobId: string) {
        return this._httpClient.get(`/api/workOrder/job-status/${jobId}`);
    }


}
